import coordinatesToAngleAndMagnitude from './coordinatesToAngleAndMagnitude';

// add magnitude and angle to a set that has at least {x, y} properties.
const enrichVectors = (datums: { x: number; y: number }[], direction?: 'from' | 'to') =>
    datums.map((datum) => {
        const { angle, magnitude } = coordinatesToAngleAndMagnitude({ x: datum.x, y: datum.y, direction });

        return { ...datum, magnitude, angle };
    });

export default enrichVectors;
